import { render, staticRenderFns } from "./StainLineItem.vue?vue&type=template&id=2a524d58&scoped=true&"
import script from "./StainLineItem.vue?vue&type=script&lang=ts&"
export * from "./StainLineItem.vue?vue&type=script&lang=ts&"
import style0 from "./StainLineItem.vue?vue&type=style&index=0&id=2a524d58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a524d58",
  null
  
)

export default component.exports